import React from 'react';
import { motion } from 'framer-motion';
import { Twitter, ExternalLink } from 'lucide-react';
import dengsLogo from '../../assets/dengs.png';

export function Footer() {
  const socialLinks = [
    { 
      icon: Twitter, 
      href: 'https://x.com/DENGSonApe', 
      label: 'DENGS Twitter',
      title: 'Follow DENGS',
      className: 'text-yellow-400 hover:bg-yellow-500/20'
    },
    { 
      icon: Twitter, 
      href: 'https://x.com/0xAfzal', 
      label: '0xAfzal Twitter',
      title: 'Follow 0xAfzal',
      className: 'text-blue-400 hover:bg-blue-500/20'
    }
  ];

  const quickLinks = [
    { 
      label: 'Dengs Homepage', 
      href: 'https://dengsonape.com',
      icon: ExternalLink 
    },
    { 
      label: 'Mine $GEM', 
      href: 'https://frostbyte.art',
      icon: ExternalLink 
    },
    { 
      label: 'Mine Gold', 
      href: 'https://themine.io',
      icon: ExternalLink 
    },
  ];

  return (
    <footer className="mt-auto bg-slate-950/95 backdrop-blur-md border-t border-blue-500/20">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {/* Brand Section */}
          <div className="space-y-4">
            <motion.div
              className="flex items-center"
              whileHover={{ scale: 1.05 }}
            >
              <img 
                src={dengsLogo} 
                alt="DengSniper Logo" 
                className="w-8 h-8 object-contain"
              />
              <span className="ml-2 text-xl font-bold bg-gradient-to-r from-blue-400 to-blue-600 text-transparent bg-clip-text">
                DengSniper
              </span>
            </motion.div>
            <p className="text-gray-400 text-sm">
              Your essential tool for uncovering tokens actively mining in the Frostbyte Mines. 
              Stay ahead in the fast-paced crypto landscape by discovering which tokens and collections 
              are currently mining $GEM 💎
            </p>
          </div>

          {/* Quick Links */}
          <div className="space-y-4">
            <h3 className="text-white font-semibold">Quick Links</h3>
            <ul className="space-y-2">
              {quickLinks.map((link) => (
                <li key={link.label}>
                  <motion.a
                    href={link.href}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="flex items-center gap-2 text-gray-400 hover:text-blue-400 text-sm transition-colors group"
                    whileHover={{ x: 5 }}
                  >
                    <span>{link.label}</span>
                    <link.icon className="w-3 h-3 opacity-0 group-hover:opacity-100 transition-opacity" />
                  </motion.a>
                </li>
              ))}
            </ul>
          </div>

          {/* Social Links */}
          <div className="space-y-4">
            <h3 className="text-white font-semibold">Connect With Us</h3>
            <div className="flex flex-wrap gap-4">
              {socialLinks.map((social) => (
                <motion.a
                  key={social.label}
                  href={social.href}
                  target="_blank"
                  rel="noopener noreferrer"
                  className={`p-2 bg-blue-500/10 rounded-lg transition-colors ${social.className}`}
                  whileHover={{ scale: 1.1, rotate: 5 }}
                  whileTap={{ scale: 0.9 }}
                  aria-label={social.label}
                  title={social.title}
                >
                  <social.icon className="w-5 h-5" />
                </motion.a>
              ))}
            </div>
          </div>
        </div>

        {/* Copyright */}
        <div className="mt-8 pt-8 border-t border-blue-500/20 flex flex-col md:flex-row justify-between items-center">
          <p className="text-gray-400 text-sm">
            © {new Date().getFullYear()} DengSniper. All rights reserved.
          </p>
          <p className="text-gray-400 text-sm mt-2 md:mt-0">
            Built with ❄️ for ApeChain community by{' '}
            <a 
              href="https://x.com/0xAfzal"
              target="_blank"
              rel="noopener noreferrer"
              className="text-blue-400 hover:text-blue-300 transition-colors"
            >
              0xAfzal
            </a>
          </p>
        </div>
      </div>
    </footer>
  );
}